export default {
	validate: {},
	locales: {
		en: 'Англійська',
		ru: 'Російська',
		uk: 'Українська'
	},
	cities: {
		kyv: 'Київ',
		umn: 'Умань',
		vin: 'Вінниця'
	},
	menu: {
		Login: 'Вхід',
		Register: 'Реєстрація',
		Dashboard: 'Панель'
	},
	buttons: {
		confirm: 'Підтвердити',
		cancel: 'Скасувати',
		repeat: 'Повторити',
		ok: 'OK'
	},
	pages: {
		Login: {
			title: 'Вхід у систему',
			submit: 'Увійти',
			confirm: 'Підтвердіть вхід',
			withoutSMS: 'Нeмає смс або змінити номер?',
			problemWithCode: 'Не можете отримати код підтвердження?',
			changePhone: 'Змінити номер телефону',
			dontGetSms: 'Не отримано SMS',
			form: {
				phoneNumber: {
					countrySelectorLabel: 'Код країни',
					countrySelectorError: 'Оберіть країну',
					phoneNumberLabel: 'Номер телефону',
					example: 'Наприклад: '
				}
			}
		},
		Dashboard: {
			streets: {
				noResults: 'Немає схожих результатів',
				0: 'Звідки - Почніть вводити для пошуку ...',
				1: 'Куди - Почніть вводити для пошуку ...'
			},
			house: 'Будинок',
			statuses: {
				searching: 'Пошук',
				'driver-assigned': 'Водія знайдено',
				arrived: 'Водій прибув',
				cancelled: 'Відмінено'
			},
			reverseSearch: 'Вибрати точку на карті',
			outCity: 'За містом',
			continueSearch: 'Продовжуйте пошук',
			rate: 'Тариф',
			options: 'Опції',
			driver: 'Водій',
			others: 'інших',
			yourOrder: 'Ваше замовлення',
			orderTaxi: 'Замовити таксі',
			createAnotherOrder: 'Створити інше замовлення',
			canCancelOrder: 'Ви дійсно хочете скасувати дане замовлення?',
			cancelDescription: 'Через часті скасування вже прийнятих водіями замовлень, можливість створювати нові замовлення може бути заблокована на деякий час.',
			noItems: 'Не знайдено',
			comment: 'Коментар'
		},
		404: {
			title: 'Упсс!',
			text: 'Схоже, ви перебуваєте на незвіданій території. Ми ще не знаємо про цю сторінку. На щастя, ми знаємо зворотній шлях.',
			return: 'Назад'
		}
	},
	messages: {
		info: {
			pushLoginCode: 'На ваш телефон надіслано SMS з кодом підтвердження'
		},
		success: {
			login: 'Ласкаво просимо до нас!'
		},
		error: {
			incorrectConfirmCode: 'Введено невірний код підтвердження',
			unknown: 'Невідома помилка',
			incorrectEnterNumber: 'Введіть число'
		}
	},
	noDataText: 'not items'
}
